export enum EnumTipoConfiguracaoEmail {
    REDIRECIONAMENTO_ALIAS = "REDIRECIONAMENTO_ALIAS",
    ACESSO_DIRETO_CAIXA = "ACESSO_DIRETO_CAIXA"
}